/**
 * This component will show one text and its english subtitle if needed
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { css } from 'lib/paypalphrodite'

export default class EnglishSubtitleText extends Component {
  static propTypes = {
    showENSubTextRTR: PropTypes.bool,
    styles: PropTypes.object,
    text: PropTypes.string,
    enSubText: PropTypes.string,
  }

  render() {
    const { showENSubTextRTR, styles = {}, text, enSubText = '' } = this.props

    return (
      <>
        {showENSubTextRTR ? (
          <>
            <div className={css(styles.rtrPrimaryText)}>{text}</div>
            <div className={css(styles.rtrENSubText)}>{enSubText}</div>
          </>
        ) : (
          text
        )}
      </>
    )
  }
}
